export const generateBattleStyleColor = (battleRemaining, battleTotal) => {
  const battlePercent = (battleTotal - battleRemaining) / battleTotal * 100;
  return battlePercent < 50 ? 'green' : battlePercent >= 80 ? 'red' : 'yellow';
};